import { useContext, useEffect, useMemo } from 'react';

import { Form as FormAntd } from 'antd';

import {
  ColSize,
  ContentSection,
  RowSize,
} from '../../../../../../../../../../../shared/components';
import { SelectForm } from '../../../../../../../../../../../shared/components/Form';

import { GenericDataFormContext } from '../../../../../../../shared/contexts';
import { StepThreeFormContext } from '../../../../contexts/StepThreeForm';

import { ValidateForm } from '../../../../../../../../../../../shared/utils';

import './index.css';

interface PropertyDataSectionProps {
  duplicateId?: number;
  id: number;
}

export const PropertyDataSection = ({
  duplicateId,
  id,
}: PropertyDataSectionProps) => {
  const validateForm = new ValidateForm();

  const {
    getLocalitiesPerProvince,
    isLoadingLocalities,
    isLoadingProvinceList,
    getLocalitiesByProvinceFromState,
    provinceList,
    setLocalities,
  } = useContext(GenericDataFormContext);
  const { stepThreeForm } = useContext(StepThreeFormContext);

  const provinceFormItemName = `province-tab-${id}`;
  const provinceSelected: string = FormAntd.useWatch(
    provinceFormItemName,
    stepThreeForm
  );

  const localities = useMemo(
    () => getLocalitiesByProvinceFromState(provinceSelected),
    [getLocalitiesByProvinceFromState, provinceSelected]
  );

  const onSelectProvince = async () => {
    stepThreeForm?.resetFields([`location-tab-${id}`]);

    setLocalities([]);
  };

  useEffect(() => {
    if (provinceSelected?.length) getLocalitiesPerProvince(provinceSelected);
  }, [provinceSelected, getLocalitiesPerProvince]);

  useEffect(() => {
    if (duplicateId) {
      const allFieldsValues = stepThreeForm?.getFieldsValue(true);

      const duplicatedFieldsValues = Object.keys(allFieldsValues).reduce(
        (acc, key) => {
          if (key.includes(`-tab-${duplicateId}`)) {
            const newKey = key.replace(`-tab-${duplicateId}`, `-tab-${id}`);
            acc[newKey] = allFieldsValues[key];
          }

          return acc;
        },
        {} as Record<string, any>
      );

      stepThreeForm?.setFieldsValue(duplicatedFieldsValues);
    }
  }, [duplicateId, id, stepThreeForm]);

  useEffect(() => {
    setLocalities([]);
    /* eslint-disable-next-line */
  }, []);

  return (
    <ContentSection level='h3' title='Datos del bien'>
      <RowSize>
        <ColSize size={25}>
          <SelectForm
            formProps={{
              label: 'Provincia:',
              name: `province-tab-${id}`,
              rules: validateForm.generateRules({
                label: 'provincia',
                rules: ['required'],
              }),
            }}
            selectProps={{
              loading: isLoadingProvinceList,
              onSelect: onSelectProvince,
              options: provinceList,
              showSearch: true,
            }}
          />
        </ColSize>

        <ColSize size={25}>
          <SelectForm
            formProps={{
              label: 'Localidad:',
              name: `location-tab-${id}`,
              rules: validateForm.generateRules({
                label: 'localidad',
                rules: ['required'],
              }),
            }}
            selectProps={{
              disabled: isLoadingLocalities || !localities?.length,
              loading: isLoadingLocalities,
              options: localities,
              showSearch: true,
            }}
          />
        </ColSize>
      </RowSize>
    </ContentSection>
  );
};
